module.exports = __webpack_public_path__ + "static/media/reasons-members-mobile.99bded48.png";